/*
 * Purpose : Tool declation form add and edit form main page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */


import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import { Button, Alert, Modal, ModalBody, ModalHeader, ModalFooter, Progress} from 'reactstrap'
import axios from 'axios';

import {PostFormService} from './../../services/PostFormDataService';
import {GetFileDataService} from './../../services/GetFileDataService';
import LoadingModal from '../../components/UI/modals/loadingModal';
import { errorConstants, successConstants, htmlConstants } from './../../config/constants';
import './InputForm.css'
import { formDefinition, initialFormValues, toolPhotos, requiredFields, fileDefaultValues } from '../../config/form-input-definition';
import FormBuilder from './../FormBuilder/FormBuilder';

//amplify config
import { createExcesstransactions} from './../../graphql/mutations';
import { API, graphqlOperation } from 'aws-amplify';

import { Col, Row } from "reactstrap";
import BackButton from "../UI/Buttons/BackButton/BackButton"

const postform = new PostFormService();
const getFileData = new GetFileDataService();



export default class InputForm extends Component {

    constructor() {
        super()
        console.log("InputForm Component imported")
        this.state = {
            items: [],
            error: false,
            errorMsg: "",
            values: initialFormValues,
            photos: toolPhotos,
            files: fileDefaultValues,
            missing: [],
            success: false,
            progressValue: 0,
            draft: false,
            cfmdraft: false,
            loading: false,
            alertModal:false,
            locations:[],
            fabs:[],
            modules:[],
            umesEqpIdList:[],
            txnUniqueId:"",
            txnsupplier:"",
            toolidLength:0,
            eqpIdLength:1
        }
        this.initialValues = {}
        this.missing = []
        this.transactionid = ""
        this.formdata = {}
        this.newRows = []        

        this.handleTextChange = this.handleTextChange.bind(this)
        this.submitForm = this.submitForm.bind(this)
        this.handleDateChange = this.handleDateChange.bind(this)
        this.handleSelectChange = this.handleSelectChange.bind(this)
        this.handleRadioChange = this.handleRadioChange.bind(this)
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this)
        this.handleNumberChange = this.handleNumberChange.bind(this)
        this.handleFileChange = this.handleFileChange.bind(this)
        this.handleFileRemove = this.handleFileRemove.bind(this)
        this.buildComponent = this.buildComponent.bind(this)
        this.getInitialState = this.getInitialState.bind(this)
        this.resetComponent = this.resetComponent.bind(this)
        this.makeFormValues = this.makeFormValues.bind(this)
        this.exitForm = this.exitForm.bind(this)
    }

    // initial values of the form
    getInitialState = () => {
        return {
            items: [],
            error: false,
            errorMsg: "",
            values: initialFormValues,
            photos: toolPhotos,
            files: fileDefaultValues,
            missing: [],
            success: false,
            progressValue: 0
        }
    }

    // to handle text input values
    handleTextChange = async (e) => {
        this.updateStateValues(e.target.name, e.target.value.trim())
        if(e.target.name === "transaction-toolid"){
            this.setState({ loading: true })
            // verify dupliate toolid
            let txnId = window.location.pathname.split("/")[2] ? window.location.pathname.split("/")[2] : ""
            await getFileData.checkDuplicateToolId(e.target.value.trim(),txnId).then(
                ToolLength => {
                
                    ToolLength > 0 
                    ? 
                    document.getElementById('transaction-toolid').style.borderColor = "red"
                    :
                    document.getElementById('transaction-toolid').style.borderColor = ""

                    this.setState( {
                            ...this.state,
                            toolidLength:ToolLength,
                            loading: false
                    })
            })
            return
        }
    }

    // to handle number input values
    handleNumberChange = (e) => {
        this.updateStateValues(e.target.name, e.target.value)
    }

    // to handle date input values
    handleDateChange = (e) => {
        this.updateStateValues(e.target.name, e.target.value)
    }

    // to handle date input values
    handleSelectChange = async (e) => {        
        
        this.updateStateValues(e.target.name, e.target.value.trim())
        //console.log("e.target.name==>",e.target.name)
        //console.log("e.target.name==>",e.target.value)
        
        if(e.target.name === "transaction-txnfab"){
            this.setState({ loading: true })
            // get module list
            await getFileData.getModules(e.target.value.trim()).then( module => {
                this.setState( {
                        ...this.state,
                        modules :[...module]
                    },
                    () => {
                        //console.log("modules in state ==>",this.state.modules)
                        this.buildComponent();
                    }
                )
            })
            this.setState({ loading: false })
            return
        }
        if(e.target.name === "transaction-txnmodule"){
            this.setState({ loading: true })
            // get uems id list
            await getFileData.getUmesEqpId(this.state.values.transaction.txnfab,e.target.value.trim()).then( uemseqptid => {
                //console.log("uemseqptid==>",uemseqptid)
                this.setState( {
                        ...this.state,
                        umesEqpIdList :[...uemseqptid]
                    },
                    () => {
                        //console.log("uems eqpt id list in state ==>",this.state.umesEqpIdList)
                        this.buildComponent();
                    }
                )
            })
            this.setState({ loading: false })
            return
        }
        if(e.target.name === "transaction-txnuemseqptid"){
            this.setState({ loading: true })
            const uemsid = e.target.value.trim();
            document.getElementById('transaction-txnuemseqptid').style.borderColor = ""
            
            if(uemsid === "..." || uemsid === "NA" || uemsid === "Not available from UEMS"){
                this.setState({ loading: false })
                return
            }
            
            
            this.updateStateValues("transaction-toolid", uemsid)
            document.getElementById("transaction-toolid").value = uemsid;
            // get uems id list            
            await getFileData.getSupplier(
                this.state.values.transaction.txnfab,this.state.values.transaction.txnmodule, e.target.value.trim())
            .then( uemseqptid => {
                    console.log("uemseqptid==>",uemseqptid.split("~"))

                    if(uemseqptid.split("~").length > 1){
                        this.state.values.transaction.txnuniquesutlid = uemseqptid.split("~")[0]
                        this.state.values.transaction.txn_assets_mgt_status = uemseqptid.split("~")[2] && uemseqptid.split("~")[2]
                        this.state.values.transaction.txn_uems_remarks = uemseqptid.split("~")[3] && uemseqptid.split("~")[3]

                        this.updateStateValues("general-vendorsupplier", uemseqptid.split("~")[1])
                        document.getElementById("general-vendorsupplier").value = uemseqptid.split("~")[1];
                        document.getElementById("general-vendorsupplier").readOnly = true;                
                    }
                    
            })
            this.setState({ loading: false, eqpIdLength:1 })
            return
        }
                
    }

    // to handle radio button input values
    handleRadioChange = (e) => {
        this.updateStateValues(e.target.name, e.target.value.trim())
    }

    // to handle check box input values
    handleCheckBoxChange = (e) => {
        if (e.target.checked) {
            this.updateStateValues(e.target.name, "OK")
        }
    }

    // to handle file input values
    handleFileChange = (e) => {
        let files = { ...this.state.files }
        if (e instanceof Array) {
            e.forEach(evt => {
                files[evt.name] = files[evt.name].concat([...evt.files])
            });
        }
        else {
            files[e.target.name] = files[e.target.name].concat([...e.target.files])
        }
        this.setState({
            ...this.state,
            files//...this.state.files = files
        })

    }

    // to handle file removal
    handleFileRemove = (photoItem, sectionName) => {
        let files = fileDefaultValues
        let photos = { ...this.state.photos }

        //const photoElements = ['transactionid', 'systemtype', 'description', 'toolpicture', 'toolfilename', 'mimetype', 'md5']
        const photoElements = ['transactionid', 'systemtype', 'toolpicture', 'toolfilename', 'mimetype', 'md5'] // to maintain the description for all the section same
        
        const section = sectionName.split("-")[1];
        const splitPhotoItem = photoItem.split('_');

        //Delete the photos from the corresponding section.
        for (let elm of photoElements) {
            const itemValue = splitPhotoItem.length > 1 ? `${elm}_${splitPhotoItem[1]}` : `${elm}`
            delete photos.photos[section][itemValue];
        }

        this.setState({
                ...this.state,
                files,
                photos
            },
            () => {
                //Delete the elements from formdata object and build the components
                photoElements.forEach(elm => {
                    const formKey = splitPhotoItem.length > 1 ? `photos-${section}-${elm}_${splitPhotoItem[1]}` : `photos-${section}-${elm}`;
                    delete this.formdata[formKey];
                });
                this.buildComponent();
            }
        )
    }

    // to update state values on all the input changes
    updateStateValues = (inputName, value) => {
        const values = inputName.indexOf("photo") !== -1 ? { ...this.state.photos } : { ...this.state.values }
        const stateKey = inputName.indexOf("photo") !== -1 ? "photos" : "values"
        try {
            const name = inputName
            if (name) {
                const names = name.split("-")
                if (names.length <= 1) {
                    throw Error("incorrect names for input")
                }
                if (names.length === 2 && values[names[0]] !== undefined) {
                    if (values[names[0]] instanceof Array) {
                        if (names[1].split("_").length === 1) {
                            values[names[0]][0][names[1]] = value
                        }
                        else {
                            const addlItemName = names[1].split("_")
                            const itemCounter = parseInt(addlItemName[1], 10)
                            if (values[names[0]][itemCounter] !== undefined) {
                                values[names[0]][itemCounter][addlItemName[0]] = value
                            }
                            else {
                                values[names[0]].push({
                                    [addlItemName[0]]: value
                                })
                            }
                        }
                    }
                    else {
                        values[names[0]][names[1]] = value
                    }
                }
                else if (names.length === 3 && values[names[0]][names[1]] !== undefined) {
                    if (values[names[0]][names[1]] instanceof Array) {
                        if (names[2].split("_").length === 1) {
                            values[names[0]][names[1]][0][names[2]] = value
                        }
                        else {
                            const addlItemName = names[2].split("_")
                            const itemCounter = parseInt(addlItemName[1], 10)
                            if (values[names[0]][names[1]][itemCounter] !== undefined) {
                                values[names[0]][names[1]][itemCounter][addlItemName[0]] = value
                            }
                            else {
                                values[names[0]][names[1]].push({
                                    [addlItemName[0]]: value
                                })
                            }
                        }
                    }
                    else {
                        values[names[0]][names[1]][names[2]] = value
                    }
                }
                else {
                    throw Error("initial inputs not defined")
                }
            }
            else {
                throw Error("input value not defined")
            }
            this.setState({
                ...this.state,
                [stateKey]: values,
                error: false
            })
        }
        catch (err) {
            const reqBody = {
                level:"error",
                message: "Error in update state values: "+JSON.stringify(err)
            }
            axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                            reqBody,
                            { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                        );
            this.setState({
                ...this.state,
                error: true,
                success: false,
                errorMsg: err.toString()
            })
        }
    }

    async componentDidMount() {
        this.setState({ loading: true })
        // getting locations for locations dropdown
        await getFileData.getLocations().then( locations => {
            this.setState({
                ...this.state,
                locations:locations
            })
        })
        // getting fab list for fab dropdown
        await getFileData.getFabs().then( fab => {
            this.setState({
                ...this.state,
                fabs:fab
            })
            //console.log("fabs length => ",fab.length)
        })
     
        //console.log("this.props.match=>",this.props.match)
        
        if (this.props.match && this.props.match.params && this.props.match.params.transid) {
            try {
                
            this.transactionid = this.props.match.params.transid
            //console.log("transactionid==>",this.transactionid);
            //this.setState({ loading: true })  
            await getFileData.getSavedData(this.transactionid).then( async viewDataDeails => {
                
                if (viewDataDeails.transaction.length === 0) {
                    this.setState({
                        error: true,
                        errorMsg: errorConstants.norecordsfortransaction + this.transactionid,
                    })
                    return
                }
                else if (viewDataDeails.transaction.length > 1 || viewDataDeails.general.length > 1) {                 
                    this.setState({
                        error: true,
                        errorMsg: errorConstants.toomanyrecords + this.transactionid,
                    })
                    return
                }
                // new
                //console.log("fab from initial values => ",viewDataDeails.transaction[0].txnfab," module from init values => ",viewDataDeails.transaction[0].txnmodule)
                // getting modules
                if(viewDataDeails.transaction[0].txnfab !== ""){
                    await getFileData.getModules(viewDataDeails.transaction[0].txnfab).then( module => {
                        this.setState( {
                            ...this.state,
                            modules :[...module]
                        })                
                        //console.log("fabs length => ",fab.length)
                    })
                }
                //getting uniq id
                if(viewDataDeails.transaction[0].txnfab !== "" && viewDataDeails.transaction[0].txnmodule !== ""){
                    await getFileData.getUmesEqpId(viewDataDeails.transaction[0].txnfab, viewDataDeails.transaction[0].txnmodule).then( uemseqptid => {
                        this.setState( {
                            ...this.state,
                            umesEqpIdList :[...uemseqptid]
                        })                
                        //console.log("fabs length => ",fab.length)
                    })
                }
                                // new

                this.setState({ loading: false })
                this.makeFormValues(viewDataDeails)
            })
            
            this.buildComponent()

            //this.makeFormValues(viewData)
            //this.buildComponent()
            this.setState({ alertModal:true })
            } catch (error) {
                const reqBody = {
                    level:"error",
                    message: "Error in inputform makeformcomponents or buildcomponent: "+JSON.stringify(error)
                }
                axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                reqBody,
                                { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                            );
                this.setState({
                    error: true,
                    errorMsg: errorConstants.getrequestfailed,
                    loading: false
                })
            }
        }
        else {
            this.buildComponent()
            this.setState({ loading: false })
            this.setState({ alertModal:true })
        }
    }

    makeFormValues = (formdata) => {
        const formValues = {}
        if (formdata) {
            Object.keys(formdata).forEach(section => {

                if (section.toLowerCase().trim() === "general" || section.toLowerCase().trim() === "transaction") {

                    const sectionData = formdata[section][0]

                    Object.keys(sectionData).forEach(item => {
                        const itemName = `${section}-${item.toLowerCase()}`
                        formValues[itemName] = sectionData[item] === null ? '' : sectionData[item]
                    })
                }
                else {
                    const sectionData = formdata[section]
                    if (sectionData instanceof Array) {
                        if (section.toLowerCase().trim() === "hardwarefab") {
                            sectionData.sort(function (a, b) {
                                // var nameA = a.systemtype.toUpperCase(); // ignore upper and lowercase
                                // var nameB = b.systemtype.toUpperCase(); // ignore upper and lowercase
                                var nameA = a.systemtype.toUpperCase(); // ignore upper and lowercase
                                var nameB = b.systemtype.toUpperCase(); // ignore upper and lowercase
                                if (nameA < nameB) {
                                    return -1;
                                }
                                if (nameA > nameB) {
                                    return 1;
                                }
                                return 0;
                            });
                        }
                        else {
                            if (sectionData.length > 1) {
                                this.newRows.push({
                                    key: section,
                                    count: sectionData.length - 1
                                })
                            }
                        }
                        let counter = 0
                        sectionData.forEach((row, index) => {
                            Object.keys(row).forEach(item => {
                                let itemName = ""
                                if (row.systemtype) {
                                    const mid = row.systemtype.split(" ")[0].toLowerCase().trim()

                                    if (index !== 0 && row.systemtype !== sectionData[index - 1].systemtype) {
                                        if (counter > 1) {
                                            this.newRows.push({
                                                key: sectionData[index - 1].systemtype.split(" ")[0].toLowerCase().trim(),
                                                count: counter - 1
                                            })
                                        }
                                        counter = 0;
                                    }

                                    const suffix = counter !== 0 ? `_${counter}` : ""
                                    itemName = `${section}-${mid}-${item.toLowerCase()}${suffix}`

                                } else {
                                    const suffix = index !== 0 ? `_${index}` : ""
                                    itemName = `${section}-${item.toLowerCase()}${suffix}`
                                }
                                formValues[itemName] = row[item] === null ? '' : row[item]
                            })
                            counter++
                            if (row.systemtype && index === sectionData.length - 1) {
                                if (counter > 1) {
                                    this.newRows.push({
                                        key: sectionData[index].systemtype.split(" ")[0].toLowerCase().trim(),
                                        count: counter - 1
                                    })
                                }
                            }
                        })
                    }
                }
            })
            //console.log("formValues==>",formValues)
            this.formdata = formValues
            // Set the values
            Object.keys(this.formdata).forEach(input => {
                this.updateStateValues(input, typeof this.formdata[input] === "number" ? this.formdata[input].toString() : this.formdata[input])
            })
            //console.log("input this.props.user =>",this.props.user)
            //console.log("input formData =>",this.state.values.transaction.initiator)            
        }
    }

    buildComponent = (error, errorMsg) => {
        const items = []
        try {
            let finalLocactions = this.state.locations instanceof Array ? this.state.locations : ["..."]
            //console.log("this.state.locations====>",this.state.locations instanceof Array && this.state.locations.length)
            //fabs
            let finalFabs = this.state.fabs instanceof Array ? this.state.fabs : ["..."]
            //console.log("this.state.fabs====>",this.state.fabs instanceof Array && this.state.fabs.length)
            //modules
            let finalModules = this.state.modules instanceof Array ? this.state.modules : ["...","NA"]
            //console.log("this.state.modules====>",this.state.modules instanceof Array && this.state.modules.length)
            //uemseqptids
            let finalUemsEqptIdList = this.state.umesEqpIdList instanceof Array ? this.state.umesEqpIdList : ["...","NA","Not available from UEMS"]
            //console.log("this.state.uemsEqptList====>",this.state.umesEqpIdList instanceof Array && this.state.umesEqpIdList.length)

            if (formDefinition.title && formDefinition.data && formDefinition.data instanceof Array) {
                if (formDefinition.items && formDefinition.items instanceof Array) {
                    const mainItems = {}
                    mainItems.items = formDefinition.items
                    items.push(
                        <FormBuilder
                            data={mainItems}
                            key={"main-items"}                            
                            locations={finalLocactions}
                            txnFabs={finalFabs}
                            txnModules={finalModules}
                            txnUemsEqptIdList={finalUemsEqptIdList}
                            missingFields={this.missing}
                            handleTextChange={this.handleTextChange}
                            handleDateChange={this.handleDateChange}
                            handleSelectChange={this.handleSelectChange}
                            handleRadioChange={this.handleRadioChange}
                            handleCheckBoxChange={this.handleCheckBoxChange}
                            handleNumberChange={this.handleNumberChange}
                            handleFileChange={this.handleFileChange}
                            handleFileRemove={this.handleFileRemove}
                            formValues={this.formdata}
                            newRows={this.newRows} />
                    )
                }
                formDefinition.data.forEach((item, index) => {
                    items.push(                        
                        <FormBuilder
                            data={item}
                            key={index}
                            locations={finalLocactions}
                            txnFabs={finalFabs}
                            txnModules={finalModules}
                            txnUemsEqptIdList={finalUemsEqptIdList}
                            missingFields={this.missing}
                            handleTextChange={this.handleTextChange}
                            handleDateChange={this.handleDateChange}
                            handleSelectChange={this.handleSelectChange}
                            handleRadioChange={this.handleRadioChange}
                            handleCheckBoxChange={this.handleCheckBoxChange}
                            handleNumberChange={this.handleNumberChange}
                            handleFileChange={this.handleFileChange}
                            handleFileRemove={this.handleFileRemove}
                            formValues={this.formdata}
                            newRows={this.newRows} />
                    )
                })
                this.setState({
                    ...this.state,
                    items,
                    error: error ? error : false,
                    errorMsg: errorMsg ? errorMsg : ""
                })
            }
            else {
                throw Error("Input form not defined")
            }
        }
        catch (err) {
            this.setState({
                ...this.state,
                error: true,
                success: false,
                errorMsg: errorConstants.errorloading
            })
        }
    }

    resetComponent = () => {
        this.setState({ success: false, cfmdraft: false })
        // this.buildComponent()
        //window.location.href = "/"
        window.location.href =`/transactions`
    }
    exitForm = () => {
        this.setState({
            cfmdraft: true
        })
    }
    render() {
        return (
            <div className={"form"}>
                    <LoadingModal open={this.state.loading} msg='Processing the request..  It may take a few moments..' />
                    {/* <UncontrolledAlert color="primary">{htmlConstants.saveinfo}</UncontrolledAlert> */}
                    <Alert color="danger" isOpen={this.state.toolidLength > 0}>{errorConstants.duplicatetoolid}</Alert>
                    <div className="topBtnDivDecForm" >
                        <Row form style={{ justifyContent: "flex-end" }}>
                            <Col md="auto">
                                <BackButton path="/retirementform" label="Go Back To Form Home"/>
                            </Col>                    
                            <Col md="auto">
                                <BackButton path="/transactions" label="Go Back to Transactions"/>
                            </Col>                    
                        </Row>
                    </div>
                    {this.state.items}
                    <Alert color="danger" isOpen={this.state.toolidLength > 0}>{errorConstants.duplicatetoolid}</Alert>
                    <Alert color="danger" isOpen={this.state.eqpIdLength === 0 }>Tool {this.state.values.transaction && this.state.values.transaction.txnuemseqptid} no longer available from UEMS. Please select available UEMS Eqpt ID</Alert>
                    <Alert color="danger" isOpen={this.state.error}>{this.state.errorMsg}</Alert>
                    {this.state.items.length > 0 ? <div className={"submit"} style={{textAlign:"center"}}>
                        <Button style={{margin:"10px", backgroundColor:"#fb8734"}} onClick={() => this.submitForm(false)} >Submit Form</Button>
                        <Button style={{margin:"10px"}} onClick={() => this.submitForm(true)} >Save As Draft</Button>
                    </div> : ''}
                    <br /><br /><br />
                    <Modal isOpen={this.state.success} >
                        <ModalHeader >Success!</ModalHeader>
                        <ModalBody>
                            {this.state.draft ? successConstants.formsaved : successConstants.formsubmitted}
                        </ModalBody>
                        <ModalFooter>
                            {/* <NavLink style={{ textDecoration: 'none',color: 'black' }} to='/transactions' exact> */}
                                <Button color="primary" onClick={this.resetComponent}>OK</Button>{' '}
                                {/* <Button color="primary">OK</Button>{' '} */}
                            {/* </NavLink> */}
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={this.state.cfmdraft} >
                        <ModalHeader >Save Declaration Form</ModalHeader>
                        <ModalBody>
                            {htmlConstants.confirmsave}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={() => this.submitForm(true)}>Save</Button>{' '}
                            <Button color="secondary" onClick={this.resetComponent}>Cancel</Button>{' '}
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={this.state.progressValue !== 0} >
                        <ModalHeader >Uploading Photos</ModalHeader>
                        <ModalBody>
                            <div className="text-center">{this.state.progressValue + " %"}</div>
                            <Progress value={"" + this.state.progressValue} />
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={this.state.alertModal} toggle={() => this.setState({ alertModal:false })} size="lg" draggable={false} centered={true}>
                        {/* <ModalHeader toggle={() => this.setState({ alertModal:false })} ></ModalHeader> */}
                        <ModalBody>
                            <Alert color="success">
                                <h4 className="alert-heading"><u>Note!</u></h4>
                                <p>
                                    {htmlConstants.toolpictureformat}<br/>
                                    {htmlConstants.toolpicturesize}<br/>
                                    {htmlConstants.confileformat}<br/>
                                    {htmlConstants.confilesize}<br/>
                                    {htmlConstants.saveinfo}<br/><br/>
                                    {htmlConstants.uemsdata}
                                </p>                                
                            </Alert>
                        </ModalBody>
                    </Modal>
            </div>
        )
    }

    // call for data validation on form submission
    traverseValuesTree = (values, parent) => {
        const that = this
        for (let el of Object.keys(values)) {
            if (values[el] instanceof Array) {
                this.traverseValuesTree(values[el][0], parent ? parent + "-" + el : el)
            }
            else if (typeof values[el] === "object" && Object.keys(values[el]).length > 0) {
                this.traverseValuesTree(values[el], parent ? parent + "-" + el : el)
            }
            else if (typeof values[el] === "string" || typeof values[el] === "number") {
                if (requiredFields.includes(parent + "-" + el) && (values[el] === undefined || values[el] === "" || values[el] === "..." || values[el] === 0)) {
                    if (!that.missing.includes(parent + "-" + el)) {
                        that.missing.push(parent + "-" + el)
                    }
                }
                else {
                    if (that.missing.includes(parent + "-" + el)) {
                        that.missing.splice(this.missing.indexOf(parent + "-" + el), 1)
                    }
                }
            }
        }
    }

    traverseFileTree = () => {
        const files = { ...this.state.files }
        const that = this
        Object.keys(files).forEach(file => {
            if (requiredFields.includes(file) && (files[file] === "" || files[file] === undefined)) {
                if (!that.missing.includes(file)) {
                    that.missing.push(file)
                }
            }
            else {
                if (that.missing.includes(file)) {
                    that.missing.splice(that.missing.indexOf(file), 1)
                }
            }
        })
    }

    async addTransaction(req) {
        try {
        await API.graphql(graphqlOperation(createExcesstransactions, {input:{TransactionId:"999",TransactionType:"React test2",ToolId:"tool02",Approved:"DRAFT"}}))
        console.log("Api call")
        } catch (err) {
        console.log('error creating todo:', err)
        }
    }

    randomString(length, chars) {
        var result = '';
        for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }

    //submitForm = (draft) => {
    async submitForm(draft) {
        
        this.setState({ loading: true })
        // verify dupliate toolid
        //console.log("this.state.values.transaction.toolid==>",this.state.values.transaction.toolid)  
        //console.log("window.location.pathname==>",window.location.pathname.split("/")[2])
        let txnId = window.location.pathname.split("/")[2] ? window.location.pathname.split("/")[2] : ""
        await getFileData.checkDuplicateToolId(this.state.values.transaction.toolid.trim(),txnId).then(
            ToolLength => {         
                ToolLength > 0
                ? 
                document.getElementById('transaction-toolid').style.borderColor = "red"
                :
                document.getElementById('transaction-toolid').style.borderColor = ""

                this.setState( {
                        ...this.state,
                        toolidLength:ToolLength
                })
        })
        //console.log("toolidLength==>",this.state.toolidLength)
        if(this.state.toolidLength > 0 ){
            this.setState({ loading: false })
            return false;
        }        
        await getFileData.checkUEMSToolAvailability(this.state.values.transaction.txnuemseqptid.trim()).then(
            eqpIdLength => {         
                eqpIdLength === 0
                ? 
                document.getElementById('transaction-txnuemseqptid').style.borderColor = "red"
                :
                document.getElementById('transaction-txnuemseqptid').style.borderColor = ""

                this.setState( {
                        ...this.state,
                        eqpIdLength:eqpIdLength,
                        loading: false
                })
        })
        if(this.state.eqpIdLength === 0 ){
            return false;
        }


        if (!draft) {
            this.traverseValuesTree({ ...this.state.values }, "")
            this.traverseValuesTree({ ...this.state.photos }, "")
            this.traverseFileTree()
            if (this.missing.length > 0) {
                this.buildComponent(true, errorConstants.missingreqfields)
                return
            }
        }
        
        this.setState({
            ...this.state,
            error: false,
            loading: true,
            errorMsg: ""
        })
        const restInput = {
            values: this.state.values,
            draft
        }
        //console.log('restInput=====>',restInput)
        try {
            const result = await postform.postForm(this.props.user,restInput);
            //console.log("transactionId==>",result)
            const returnValues = result.split("~");
            const transactionId = returnValues[0]
            const toolId = returnValues[1]
            const oldTransId = returnValues[2]
            const requester = returnValues[3] ? returnValues[3] : this.props.user

            if(transactionId){
                try {
                    console.log("form Data submitted")
                    const formData = new FormData()
                    const files = { ...this.state.files }
                    const photos = { ...this.state.photos }
                    Object.keys(photos.photos).forEach(section => {
                        const fileName = `photos-${section}-files`
                        if (files[fileName] !== "") {
                            Array.from(files[fileName]).forEach((f, i) => {
                                formData.append(`photos-${section}-description-${i}`, photos.photos[section].description)
                                formData.append(fileName + "-" + i, f)
                            })
                        }
                        else {
                            formData.append(`photos-${section}-description-0`, photos.photos[section].description)
                        }
                    })
                    let result = null;
                    try {
                        //result = await postform.postFileData(transactionId,toolId,formData,draft);
                        result = await postform.postFileData(transactionId,toolId,formData,draft,requester);
                    }catch(error) {
                        const reqBody = {
                            level:"error",
                            message: "Error in posting file data : "+error
                        }
                        axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                        reqBody,
                                        { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                                    );

                        this.setState({ ...this.state, progresValue: 0 })
                        this.setState({
                            ...this.state,
                            error: true,
                            success: false,
                            loading: false,
                            errorMsg: errorConstants.serverreqfailed,
                            progressValue: 0

                        })
                        //postform.removeTransaction(transactionId); // to be revisited
                        //throw new Error("Error in posting file data : "+error)
                        return 
                    }
                    //console.log("transactionId==>",result)
                    if(result){
                        let message=null;
                        if(!draft){
                            message = "Form is Submitted. loginuser : "+this.props.user+" , transactionId : "+transactionId+" , toolid : "+toolId                            
                        }
                        else{
                            message = "Form is Saved. loginuser : "+this.props.user+" , transactionId : "+transactionId+" , toolid : "+toolId                            
                        }                            
                
                        if(oldTransId !== "undefined"){
                            console.log("oldTransId==>",oldTransId)
                            await postform.removeTransaction(oldTransId) //deletes the old record
                            console.log("Records were removed")
                        }                            
                        //throw new Error("error by me")
                        const reqBody = {
                            level:"info",
                            message: message
                        }
                        axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                        reqBody,
                                        { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                                    );                           
                        
                        this.setState({
                            ...this.state,
                            success: true,
                            draft,
                            loading: false
                        });
                    }else{
                        this.setState({
                            ...this.state,
                            error: true,
                            success: false,
                            loading: false,
                            errorMsg: errorConstants.serverreqfailed,
                            progressValue: 0
                        })
                    }    
                    
                } catch (error) {
                    //await postform.removeTransaction(transactionId) // to be revisited
                    const reqBody = {
                        level:"error",
                        message: "Error in insert/removing data xcess form data : "+error
                    }
                    axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                                    reqBody,
                                    { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                                );
                    //throw new Error("Error inserting excess form data. Please check logs for more details")    
                    return
                }
            }
            else{
                throw new Error("Error inserting excess form data. Please check logs for more details")
            }
        } catch (error) {
            const reqBody = {
                level:"error",
                message: "Error inserting excess form data : "+error
            }
            axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                            reqBody,
                            { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                        );
            this.setState({
                    ...this.state,
                    error: true,
                    success: false,
                    loading: false,
                    errorMsg: errorConstants.serverreqfailed    
                })
        }
    }
}